import {
  SurveyAnswerValueInterface,
  SurveyPageInterface,
  SurveyQuestionInterface,
  SurveySectionInterface,
  UserSurveyOpenInterface,
} from '@elearning-platform/api-types/interfaces';

import { EnrollEventFormDefaultValues } from '../../interfaces';

import { findAnswerId } from './findAnswerId.utils';
import { reversedFieldKeys } from './reversedFieldKeys.utils';

export const mapFormValuesToAnswers: (
  survey: UserSurveyOpenInterface,
  formValues: EnrollEventFormDefaultValues,
) => SurveyAnswerValueInterface[] = (
  survey: UserSurveyOpenInterface,
  formValues: EnrollEventFormDefaultValues,
): SurveyAnswerValueInterface[] => survey.pages.flatMap((page: SurveyPageInterface): SurveyAnswerValueInterface[] =>
  page.sections.flatMap((section: SurveySectionInterface): SurveyAnswerValueInterface[] =>
    section.questions.flatMap((question: SurveyQuestionInterface): SurveyAnswerValueInterface[] => {
      const formField: keyof EnrollEventFormDefaultValues
      = reversedFieldKeys[`${section.type}|${question.question}`] as keyof EnrollEventFormDefaultValues;
      const answerId: number | undefined = formField ? findAnswerId(question, formValues[formField]) : undefined;

      return answerId ? [{ id: answerId, value: String(formValues[formField]) }] : [];
    })
  )
);
